import { render } from "./AboutPartner.vue?vue&type=template&id=58a35d16"
import script from "./AboutPartner.vue?vue&type=script&lang=js"
export * from "./AboutPartner.vue?vue&type=script&lang=js"

import "./AboutPartner.vue?vue&type=style&index=0&id=58a35d16&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__